import context from '../config/context'

const { name, copyright } = context.branding
const recoveryCodePrefix = name.toLowerCase()

// Generic labels
export const OK = 'Ok'
export const NEXT = 'Next'
export const CANCEL = 'Cancel'
export const FINISH = 'Finish'
export const PROCEED = 'Proceed'
export const CONFIRM = 'Confirm'
export const EMAIL_PLACEHOLDER = 'email@company.com'
export const GENERIC_SERVER_ERROR =
  'Could not execute request. Please try again later'
export const NEED_HELP = 'Need help?'
export const HELP = 'help'

// TalkdeskFooter
export const FOOTER_LICENSE = copyright
export const SUPPORT = 'Support'
export const TERMS_OF_SERVICE = 'Terms of Service'
export const PRIVACY_POLICY = 'Privacy Policy'
export const GOOGLE_API_SERVICES = 'Google API Services'

// TalkdeskNavbar
export const RETURN_TO_LOGIN = 'Return to login'
export const GO_TO_LOGIN = 'Go to login'
export const LOGO_ALTERNATE_TEXT = `${name} Logo`
export const PROCEED_TO_TALKDESK = `Proceed to ${name}`
export const LOGOUT = 'Logout'

// User Settings
export const USER_SETTINGS_TITLE = 'Security settings'
export const USER_SETTINGS_DESCRIPTION = `Manage security settings for your ${name} User`
export const PROCEED_TO_LOGIN = 'Proceed to Login'
export const PROCEED_TO_SETTINGS = 'Back to Settings'

// PasswordReset
export const PASSWORD_RESET_TITLE = 'Password reset'
export const PASSWORD_RESET_MESSAGE = `Enter the email you use for ${name} and we’ll send you instructions to reset your password`
export const PASSWORD_RESET_ERROR_TITLE = 'An error occurred'
export const PASSWORD_RESET_ERROR_MESSAGE =
  'Could not execute request. Please try again later'
export const EMAIL = 'Email'
export const EMAIL_VALIDATION_MESSAGE = 'The email format is incorrect'
export const REQUEST_PASSWORD_ACTION = 'Request password reset'

// CheckEmail
export const CHECK_EMAIL_TITLE = 'Check your email'
export const CHECK_EMAIL_MESSAGE =
  "We sent you instructions to reset your password, please check your spam folder as well. In case you can't find this email, contact Support."
//Password Settings
export const PASSWORD_SETTINGS_LOCAL_LOGIN_DISABLED =
  'Change Password is not available while you’re using an external service provider to login'
export const PASSWORD_SETTINGS_TITLE = 'User password'

// PasswordChange
export const PASSWORD_CHANGE_TITLE = 'Change password'
export const CURRENT_PASSWORD = 'Current password'
export const PASSWORD = 'New password'
export const PASSWORD_CONFIRMATION = 'Confirm new password'
export const PASSWORD_CHANGE_ACTION = 'Change password'

// PasswordChange errors
export const DIFFERENT_PASSWORDS_ERROR_MESSAGE = "Passwords don't match"
export const GENERIC_PASSWORD_CHANGE_ERROR =
  'Unable to change your password. Please try again later'
export const INVALID_RESET_TOKEN_ERROR_PART_1 =
  'Unable to change your password. Request a new '
export const INVALID_RESET_TOKEN_ERROR_PART_2 = 'Password reset'
export const LOW_QUALITY_PASSWORD_ERROR_PART_1 =
  'Please choose a stronger password. '
export const CURRENT_PASSWORD_DOESNT_MATCH_MESSAGE =
  'The current password is not valid'

// AcceptInvitation
export const CONFIRM_ACCOUNT_TITLE = 'Confirm your account'

// AcceptInvitationForm
export const ACCEPT_INVITATION_FORM_NAME = 'Name'
export const ACCEPT_INVITATION_FORM_EMAIL = 'Email'
export const ACCEPT_INVITATION_FORM_PASSWORD = 'Password'
export const ACCEPT_INVITATION_FORM_CONFIRM_PASSWORD = 'Confirm password'
export const ACCEPT_INVITATION_ACTION = 'Confirm account'
export const GENERIC_INVITATION_ERROR =
  'Unable to validate your invitation. Please try again later'

// RecoveryOTPBox
export const RECOVERY_OTP_PRINT_TITTLE = 'Recovery Codes'
export const RECOVERY_OTP_DOWNLOAD_BUTTON = 'Download'
export const RECOVERY_OTP_PRINT_BUTTON = 'Print'
export const RECOVERY_OTP_COPY_BUTTON = 'Copy'
export const RECOVERY_OTP_TEXT_FILE_TITLE = `${name} Recovery Codes:\n\n`
export const RECOVERY_OTP_TEXT_FILE_NAME = `${recoveryCodePrefix}-recovery-codes.txt`

// RecoveryOTPConfiguration
export const RECOVERY_OTP_CONFIG_TITLE = 'Recovery codes'
export const RECOVERY_OTP_CONFIG_MESSAGE =
  'Please save the following recovery codes. These codes will help you login if you lose access to your configured authentication methods'
export const RECOVERY_OTP_CONFIG_BUTTON = 'Continue'

// RecoveryOTPConfirm
export const RECOVERY_OTP_CONFIRM_TITLE = 'Make sure you saved the codes'
export const RECOVERY_OTP_CONFIRM_MESSAGE =
  "You won't be able to access these codes again, make sure you saved them before proceeding"
export const RECOVERY_OTP_CONFIRM_CANCEL = 'Back'
export const RECOVERY_OTP_CONFIRM_CONTINUE = "Yes, I've saved them"

// RecoveryOTPError
export const RECOVERY_OTP_CONFIG_ERROR =
  'Unable to generate recovery codes. Please try again later'

// Setup MFA WEB_AUTHN
export const SETUP_MFA_WEB_AUTHN_TITLE = 'Setup security key'
export const SETUP_MFA_WEB_AUTHN_MESSAGE_START_REGISTRATION_STEP =
  'Make sure you have a compatible security key'
export const SETUP_MFA_WEB_AUTHN_MESSAGE_REGISTER_STEP =
  'Insert your security key. If it has a button, tap it'
export const SETUP_MFA_WEB_AUTHN_FOOTNOTE = 'Learn more about security keys'
export const SETUP_MFA_WEB_AUTHN_LOCAL_LOGIN_REQUIRED_ERROR =
  'Local login is required'
export const SETUP_MFA_WEB_AUTHN_RECOVERY_OTP_REQUIRED_ERROR = '2FA not enabled'
export const SETUP_MFA_WEB_AUTHN_INVALID_REGISTRATION_ERROR =
  'Invalid registration, please try again. If the error persists contact support'
export const SETUP_MFA_GENERIC_ERROR =
  'Failed to register, please try again. If the error persists contact support'

// Setup MFA TOTP
export const SETUP_MFA_TOTP_TITLE = 'Setup authenticator app'
export const SETUP_MFA_TOTP_MESSAGE_START_REGISTRATION_STEP =
  "If you don't have an authenticator app, please download and install it before proceeding to the next step"
export const SETUP_MFA_TOTP_MESSAGE_REGISTER_STEP =
  'Scan the QR code with the authenticator app and enter the 6-digit code below'
export const SETUP_MFA_TOTP_FOOTNOTE = 'Learn more about the authenticator app'
export const AUTHENTICATOR_APP_DOWNLOAD =
  'We suggest using Google Authenticator:'
export const SETUP_MFA_TOTP_VERIFICATION_CODE = 'Verification code'
export const SETUP_MFA_TOTP_VERIFICATION_CODE_PLACEHOLDER =
  'Enter the 6-digit code'
export const SETUP_TOTP_INVALID_OTP = 'Invalid verification code'

// MFA common
const SETUP_MFA = 'Setup'
export const SETUP_MFA_ALREADY_REGISTERED_ERROR =
  'MFA method has already been configured'
export const SETUP_ALL_MFA_ALREADY_REGISTERED_ERROR =
  'All MFA methods have already been configured'

// MFA Settings
export const MFA_TOTP_NAME = 'Authenticator App'
export const MFA_WEB_AUTHN_NAME = 'Security Key'
export const MFA_SETTINGS_ENABLE = 'Setup'
export const MFA_SETTINGS_SETUP = SETUP_MFA
export const MFA_SETTINGS_REVOKE = 'Remove'
export const MFA_SETTINGS_DISABLE = 'Disable'
export const MFA_SETTINGS_TITLE = 'Two-factor authentication'
export const MFA_SETTINGS_ACTIVE = 'Active'
export const MFA_SETTINGS_LOCAL_LOGIN_DISABLED = `Two-factor authentication in ${name} is not available while you’re using an external service provider to login`

//// Recovery Code
export const MFA_SETTINGS_RECOVERY_CODES_TITLE = RECOVERY_OTP_CONFIG_TITLE
export const MFA_SETTINGS_RECOVERY_CODES_DESCRIPTION =
  'These codes will help you login if you lose access to your configured authentication methods'
export const MFA_SETTINGS_RECOVERY_CODES_RENEW = 'Renew'
export const MFA_SETTINGS_RECOVERY_CODES_CONFIRM_SUBTITLE =
  'Are you sure you want to renew the recovery codes?'
//// TOTP
export const MFA_SETTINGS_TOTP_DESCRIPTION = 'Setup the authenticator app'
//// WEB_AUTHN
export const MFA_SETTINGS_WEB_AUTHN_DESCRIPTION =
  'Setup a security key to login'

// MFA Revoke
export const REVOKE_MFA_CONFIRM =
  'I understand, disable Two-factor authentication'
export const REVOKE_MFA_TITLE = name => 'Disable ' + name
export const REVOKE_MFA_FORM_LABEL = 'To confirm please introduce your password'
export const REVOKE_MFA_FORM_PLACEHOLDER = 'Password'
export const REVOKE_MFA_LAST_OPTION_SUBTITLE = mfaMechanism =>
  mfaMechanism +
  ' is your last method, removing it will disable two-factor authentication. Are you sure you want to proceed?'
export const REVOKE_MFA_MECHANISM_ENFORCED_MESSAGE =
  'Your admin has enforced two-factor authentication. You must setup another authentication method before removing this one'
export const REVOKE_MFA_GENERIC_ERROR =
  'Something went wrong. Please try again later'
export const REVOKE_MFA_VALIDATE_PASSWORD_ERROR =
  'Could not validate your password'

// Setup MFA Menu
export const SETUP_MFA_SELECTOR_TITLE = SETUP_MFA
export const SETUP_MFA_SELECTOR_MESSAGE =
  'Choose one of the authentication methods below'
export const MFA_SELECTOR_TOTP_DESCRIPTION = 'Setup the authenticator app'
export const MFA_SELECTOR_WEB_AUTHN_DESCRIPTION =
  'Setup a security key to login'
export const SETUP_MFA_SELECTOR_FOOTNOTE =
  'Learn more about two-factor authentication'

// Setup MFA Enforced
export const SETUP_MFA_ENFORCED_TITLE = 'Two-factor authentication'
export const SETUP_MFA_ENFORCED_SUBTITLE =
  'This account has two-factor authentication enforced by your admin. To proceed with your login, setup an authentication method'
export const SETUP_MFA_ENFORCED_ACTION_MESSAGE = SETUP_MFA
export const SETUP_MFA_ENFORCED_GENERIC_ERROR =
  'Something went wrong. Please try again later'

// Show Password Policies
export const PASSWORD_POLICIES_TITLE = 'Your password must have:'
export const PASSWORD_POLICIES_LIST_CHARACTER = ' - '
export const PASSWORD_POLICIES_NUMBER_OF_CHARACTERS = numberOfCharacters =>
  `${numberOfCharacters} characters`
export const PASSWORD_POLICIES_NUMBER_OF_UPPER_CASE_CHARACTERS = upperCaseCharacters =>
  `${upperCaseCharacters} upper case character(s)`
export const PASSWORD_POLICIES_NUMBER_OF_LOWER_CASE_CHARACTERS = lowerCaseCharacters =>
  `${lowerCaseCharacters} lower case character(s)`
export const PASSWORD_POLICIES_MIN_NUMBERS_CHARACTERS = minNumbersCharacters =>
  `${minNumbersCharacters} number(s)`
export const PASSWORD_POLICIES_NUMBER_OF_SPECIAL_CHARACTERS = specialCharacters =>
  `${specialCharacters} special character(s) !@#$%^&/(){}=?*+´\`'|"\\-_,;.:<> `
